module.exports = __webpack_public_path__ + "static/media/no_size_limit.6a33e8b5.svg";